export function getDPI() {
    const dpiDiv = document.createElement("div");
    dpiDiv.style.width = "1in";
    dpiDiv.style.height = "1in";
    dpiDiv.style.position = "absolute";
    dpiDiv.style.left = "-100%";
    document.body.appendChild(dpiDiv);
    const dpi = dpiDiv.offsetWidth;
    document.body.removeChild(dpiDiv);
    return dpi;
}
export function mmToPx(mm) {
    const dpi = getDPI();
    return (mm / 25.4) * dpi;
}
export function pxToMm(px) {
    const dpi = getDPI();
    return (px / dpi) * 25.4;
}
export async function copyStyleToNewWindowWithoutHover() {
    let styles = "";
    const styleElements = document.querySelectorAll('style, link[rel="stylesheet"]');
    for (const styleElement of styleElements) {
        if (styleElement.tagName === "LINK") {
            const response = await fetch(styleElement.href);
            let css = await response.text();
            css = css.replace(/(?:^|\})([^{]*):hover([^{]*)\{/g, "");
            styles += `<style type="text/css">${css}</style>`;
        }
        else {
            const clonedElement = styleElement.cloneNode(true);
            let styleText = clonedElement.innerHTML;
            styleText = styleText.replace(/(?:^|\})([^{]*):hover([^{]*)\{/g, "");
            clonedElement.innerHTML = styleText;
            styles += clonedElement.outerHTML;
        }
    }
    return styles;
}
/**
 * Vue 컴포넌트 또는 HTMLElement에서 실제 DOM 엘리먼트를 추출
 */
export function resolveElement(element) {
    return element.$el ?? element;
}
/**
 * 화면 전체 크기 팝업을 연다.
 * window.open()의 features 문자열은 px 단위만 지원하므로 mm 단위를 사용하면 안 된다.
 */
export function openFullSizePopup() {
    return window.open("", "_blank", `width=${screen.availWidth},height=${screen.availHeight},left=0,top=0`);
}
